import { z } from 'zod';
import { uuidSchema } from './common.schema.js';

export const MilkTypeSchema = z.object({
  milk_type_id:              uuidSchema,
  type_code:                 z.string(),
  type_name:                 z.string(),
  caloric_value_kcal_per_ml: z.number().nullable(),
  description:               z.string().nullable(),
  severity_hours:            z.number().nullable(),
  is_active:                 z.boolean(),
  display_order:             z.number().int().nullable(),
});

export const UpdateMilkTypeSchema = z.object({
  severity_hours: z.number().nullable().optional(),
  is_active:      z.boolean().optional(),
});

export type MilkType = z.infer<typeof MilkTypeSchema>;
export type UpdateMilkType = z.infer<typeof UpdateMilkTypeSchema>;
